var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location Point"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 125",
    cx: 14.5,
    cy: 12.084,
    r: 3.625,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 126",
    d: "M22.9587 11.7812C22.9587 18.5781 14.5003 25.375 14.5003 25.375C14.5003 25.375 6.04199 18.5781 6.04199 11.7812C6.04199 7.27668 9.82892 3.625 14.5003 3.625C19.1717 3.625 22.9587 7.27668 22.9587 11.7812Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPoint);
export default __webpack_public_path__ + "static/media/location-point.89b070cd78fcda36639e4dca79c6287c.svg";
export { ForwardRef as ReactComponent };